export enum EditionAppNewsMode {
  CREATE = 'CREATE',
  MODIFY = 'MODIFY',
}
